export default {
  red: `#7b1518`,
  gold: `#f5a913`,
  yellow: `#ffdc60`,
}
